import { JobStatus } from '../jobs-status.service';

export namespace JobsStatusActions {
  export class GetJobs {
    static readonly type = 'Get Jobs';

    constructor(
      public page: number = 1,
      public per_page: number = 20,
    ) {}
  }

  export class JobUpdated {
    static readonly type = 'Update Job';

    constructor(
      public id: number,
      public job: Partial<JobStatus>,
    ) {}
  }

  export class JobAdded {
    static readonly type = 'Add Job';

    constructor(public job: JobStatus) {}
  }
}
